import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TimestampPipe } from './timestamp.pipe';
import { StripHtmlPipe } from './strip-html.pipe';
import { CompactNumberFormatPipe } from './compact-number-format.pipe';
import { ArrayToStringPipe } from './array-to-string.pipe';
import { CustomNumberPipe } from './custom-number.pipe';
import { SignedNumberPipe } from './signed-number.pipe';

@NgModule({
  declarations: [
    TimestampPipe,
    StripHtmlPipe,
    CompactNumberFormatPipe,
    ArrayToStringPipe,
    CustomNumberPipe,
    SignedNumberPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    TimestampPipe,
    StripHtmlPipe,
    CompactNumberFormatPipe,
    ArrayToStringPipe,
    CustomNumberPipe,
    SignedNumberPipe
  ]
})
export class PipesModule { }
